import {sendPopupRequest} from '../../utils/portuna';

export const POLL_RANGE_NO_EXPIRED = 0;
export const POLL_RANGE_MINE       = 1;
export const POLL_RANGE_EXPIRED    = 2;
export const POLL_RANGE_ALL        = 3;

export const POLL_RANGE_NAMES: PollRangeNameMap = {
    [POLL_RANGE_ALL]: 'Alle Umfragen',
    [POLL_RANGE_MINE]: 'Unbeantwortete Umfragen',
    [POLL_RANGE_NO_EXPIRED]: 'Aktuelle Umfragen',
    [POLL_RANGE_EXPIRED]: 'Abgelaufene Umfragen',
};

export const EVENT_POLL_RANGE_NAMES: PollRangeNameMap = {
    [POLL_RANGE_ALL]: 'Alle Terminfindungen',
    [POLL_RANGE_MINE]: 'unbeantwortete Terminfindungen',
    [POLL_RANGE_NO_EXPIRED]: 'aktuelle Terminfindungen',
    [POLL_RANGE_EXPIRED]: 'abgelaufene Terminfindungen',
};

export const POLL_TYPE_POLL  = 0;
export const POLL_TYPE_EVENT = 1;

export const pollOptions: Record<PollTypes, PollTypeOptions> = {
    [POLL_TYPE_EVENT]: {
        routePrefix: 'event-',
        urlPrefix: '/event/entry/',
        term: 'Terminfindung',
        termPlural: 'Terminfindungen',
        ranges: EVENT_POLL_RANGE_NAMES,
    },
    [POLL_TYPE_POLL]: {
        routePrefix: '',
        urlPrefix: '/poll/poll/',
        term: 'Umfrage',
        termPlural: 'Umfragen',
        ranges: POLL_RANGE_NAMES,
    },
};

export const POLL_RANGE_SORT = [POLL_RANGE_ALL, POLL_RANGE_MINE, POLL_RANGE_NO_EXPIRED, POLL_RANGE_EXPIRED];

export const POLL_RANGE_SORT_MULTI_LOGIN = [POLL_RANGE_ALL, POLL_RANGE_NO_EXPIRED, POLL_RANGE_EXPIRED];

export function deletePoll(entry: PollEntry): Promise<string>
{
    const options = pollOptions[entry.type];

    return sendPopupRequest({
        type: 'delete',
        url: options.urlPrefix + 'poll-delete',
        data: {
            id: entry.id,
        },
        message: {
            headline: options.term + ' löschen',
            message: `Sind Sie sicher, dass Sie die ${options.term} <strong>${entry.title}</strong> löschen möchten?`,
            failed: `Die ${options.term} konnte nicht gelöscht werden.`,
        },
        options: {
            textIcon: 'delete_forever',
            textIconClass: 'text-danger',
            titleIcon: 'delete',
            buttonOkay: {
                type: 'danger',
                icon: 'delete',
                title: 'Löschen',
            },
        },
    });
}
